export default class SwishMatchMarketPropsModel {
  constructor(data) {
    /**
     * Stats id
     * @type {number}
     */
    this.sid = data.statsId;
    /**
    * Line
    * @type {number}
    */
    this.l = data.line;
    /**
     * Over ddd
     * @type {string}
     */
    this.oo = data.globalId.includes("over") ? +data.odd : 0;
    /**
     * Under ddd
     * @type {string}
     */
    this.uo = data.globalId.includes("under") ? +data.odd : 0;
    // we add this properties to the model, only for player props market selections
    if (data.matchPlayerId) {
      /**
       * Match player props id
       * @type {number}
       */
      this.mpid = data.matchPlayerId;
    }
    if (data.playerId) {
      /**
      * Swish player id
      * @type {number}
      */
      this.sp = data.playerId;
    }
    // we add this properties to the model, only for pre-match market selections
    if (data.preMatchMarketId) {
      /**
       * Pre-match market id
       * @type {number}
       */
      this.mmid = data.preMatchMarketId;
      /**
       * Team
       * @type {string}
       */
      this.t = data.team;
    }
  }
}